/* eslint-disable no-param-reassign */
import { Collapse } from '../../collapsible/js/global';

export default function _rsevAccordion() {
    const OPEN_SVG = `<svg class="colour" width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.8114 28.2734C29.341 35.6565 19.6891 38.0468 12.2551 33.5854C4.83207 29.1306 2.45505 19.5444 6.91876 12.1723L3.59686 10.1609L6.91877 12.1723L7.18861 11.7266C11.659 4.34345 21.3109 1.9532 28.7449 6.41457C36.1679 10.8694 38.5449 20.4556 34.0812 27.8277L33.8114 28.2734Z" fill="#FD98FF" stroke="#FF6363" stroke-width="8.33333"/></svg>`;
    const ACCORDION_SELECTOR = '[data-component="accordion-rsev"]';
    const ACCORDION_ITEM_SELECTOR = '.accordion-item-rsev';
    const ACCORDION_ITEM_CONTROL_SELECTOR = '.accordion-item-rsev__control';
    const ACCORDION_ITEM_CONTENT_SELECTOR = '.accordion-item-rsev__content';
    const ACCORDION_ITEM_ACTIVE = 'accordion-item-rsev--active';
    const ACCORDION_ITEM_COLLAPSING =
        'accordion-item-rsev__content--collapsing';
    const ACCORDION_ITEM_EXPANDING = 'accordion-item-rsev__content--expanding';
    const ACCORDION_ITEM_OPEN = 'accordion-item-rsev__content--open';
    const ACCORDION_BUTTON_OPEN = 'accordion-item-rsev__control--open';

    class Accordion {
        constructor(accordion) {
            this.accordion = accordion;
            this.options = this.accordion.dataset;
            this.accordionItems =
                accordion.querySelectorAll(ACCORDION_ITEM_SELECTOR) || [];

            this.accordionItems.forEach((accordionItem) => {
                const control = accordionItem.querySelector(
                    ACCORDION_ITEM_CONTROL_SELECTOR
                );
                if (control) {
                    accordionItem.collapse = new Collapse();

                    const { collapse } = accordionItem;

                    collapse.collapseWrapper = accordionItem;
                    collapse.shouldAnimate = true;
                    collapse.collapseButton = control;
                    collapse.collapseContent = accordionItem.querySelector(
                        ACCORDION_ITEM_CONTENT_SELECTOR
                    );

                    collapse.buttonActiveClass = ACCORDION_BUTTON_OPEN;
                    collapse.contentOpenClass = ACCORDION_ITEM_OPEN;
                    collapse.contentExpandingClass = ACCORDION_ITEM_EXPANDING;
                    collapse.contentCollapsingClass = ACCORDION_ITEM_COLLAPSING;

                    control.addEventListener('click', () => {
                        this.handleItemClick(collapse);
                    });

                    // Set initial SVG state
                    this.updateSVG(control, collapse.isOpen);
                }
            });

            this.openActiveItems();
        }

        handleItemClick(item) {
            if (item.isTransitionRunning) return;

            const currentItemState = item.collapseIsOpen;

            if (this.options.autoclose === 'true') {
                this.closeAllItems(item.collapseWrapper);
            }

            if (!currentItemState) {
                item.transitionItemOpen();
            } else {
                item.transitionItemClosed();
            }

            if (item.collapseIsOpen) {
                item.collapseWrapper.classList.add(ACCORDION_ITEM_ACTIVE);
            } else {
                item.collapseWrapper.classList.remove(ACCORDION_ITEM_ACTIVE);
            }

            this.setToggleAllStatus(this.calculateNextToggleState());

            // Update the SVG based on the current state
            this.updateSVG(item.collapseButton, item.collapseIsOpen);
        }

        updateSVG(button) {
            const iconContainer = button.querySelector(
                '.accordion-item-rsev__icon-container'
            );
            if (iconContainer) {
                iconContainer.innerHTML = OPEN_SVG;
            }
        }

        handleToggleAllClick() {
            const toggleState = this.toggleAll.getAttribute('aria-checked');
            if (
                Array.from(this.accordionItems).find(
                    (item) => item.collapse.isTransitionRunning
                )
            )
                return;

            if (toggleState === 'false') {
                this.openAllItems();
            } else {
                this.closeAllItems();
            }
        }

        calculateNextToggleState() {
            const accordionItems = Array.from(this.accordionItems).map(
                (item) => item.collapse
            );
            const allOpen = accordionItems.every(
                (item) => item.isOpen === true
            );
            const allClosed = accordionItems.every(
                (item) => item.isOpen === false
            );

            if (allOpen) return 'allOpen';
            if (allClosed) return 'allClosed';
            return 'mixed';
        }

        setToggleAllStatus(toggleState) {
            if (this.toggleAll) {
                if (toggleState === 'allOpen') {
                    this.toggleAll.setAttribute('aria-checked', true);
                    this.toggleAll.textContent =
                        this.toggleAll.dataset.collapsetext;
                } else if (toggleState === 'mixed') {
                    this.toggleAll.setAttribute('aria-checked', 'mixed');
                    this.toggleAll.textContent =
                        this.toggleAll.dataset.collapsetext;
                } else {
                    this.toggleAll.setAttribute('aria-checked', false);
                    this.toggleAll.textContent =
                        this.toggleAll.dataset.expandtext;
                }
            }
        }

        openActiveItems() {
            this.accordionItems.forEach((item) => {
                if (item.classList.contains(ACCORDION_ITEM_ACTIVE)) {
                    item.collapse.openElement();
                } else {
                    item.collapse.closeElement();
                }
                this.updateSVG(
                    item.collapse.collapseButton,
                    item.classList.contains(ACCORDION_ITEM_ACTIVE)
                );
            });
        }

        closeAllItems(exception) {
            this.accordionItems.forEach((item) => {
                if (item.collapse.collapseWrapper !== exception) {
                    item.collapse.transitionItemClosed();
                    item.collapse.collapseWrapper.classList.remove(
                        ACCORDION_ITEM_ACTIVE
                    );
                }
            });

            if (!exception) {
                this.setToggleAllStatus('allClosed'); // Set toggle all to 'Expand all'
            } else {
                this.setToggleAllStatus('mixed'); // Set toggle all to 'mixed' if we have excluded an item from closing
            }
        }
    }

    const accordionsRsev = document.querySelectorAll(ACCORDION_SELECTOR);
    accordionsRsev.forEach((accordion) => {
        const DOMItem = accordion;

        if (!DOMItem.accordion) {
            DOMItem.accordion = new Accordion(accordion);
        } else {
            DOMItem.accordion.openActiveItems();
        }
    });
}

document.addEventListener('DOMContentLoaded', _rsevAccordion);
